import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SessionsModalTypes } from '../../../../../core/legacy/reducers/modals';
import FailureModal from '../../../../legacy/components/ui/modals/FailureModal';

export const EditFailureModal: FC = () => {
    const { t } = useTranslation();

    return (
        <FailureModal
            title={t('editSession.failure.title')}
            subtitle={t('editSession.failure.subtitle')}
            modalType={SessionsModalTypes.SESSIONS_EDIT_FAILURE}
        />
    );
};
